export const FEATURE_DARKEN_PAGE = 'feature.darken_page';

export const features = {
    [FEATURE_DARKEN_PAGE]: false,
};

export const featuresToggledByCookies = {
    [FEATURE_DARKEN_PAGE]: {
        cookieName: 'search_darken_page',
        isEnabled: cookieValue => cookieValue === 'b',
    },
};
